<template>
  <!--
      	作者：gmshop
      	时间：2019-06-04
      	描述：插件中心-分销-分销设置-页面背景图
      -->
  <div class="test-wrap mt30">
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <el-form-item label="答题图片">
        <el-button type="primary" plain icon="el-icon-upload" @click="openUpload(1)">上传图片</el-button>
        <div v-if="form.topic != ''" class="img"><img :src="form.topic" width="400" height="227" /></div>
        <!-- <div class="tips">尺寸：宽750像素 高度227像素</div> -->
      </el-form-item>

      <el-form-item label="答题活动介绍  ">
        <el-input v-model="form.topic_dec" type="textarea" rows="5" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="随机抽取题目数">
        <el-input v-model="form.topic_num" type="number"  class="max-w460">
          <template slot="append">道</template>
        </el-input>
        <div class="tips">当系统题目数小于输入数字时，则取系统当前所以题目数为准</div>
      </el-form-item>
      <!-- <el-form-item label="用户每天可答题的次数">
        <el-input v-model="form.answer_num" type="number"  class="max-w460">
          <template slot="append">次</template>
        </el-input>

      </el-form-item> -->
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import Upload from '@/components/file/Upload';
import TopicApi from '@/api/topic.js';
export default {
  components: {
    Upload: Upload
  },
  data() {
    return {
      form: {
        topic: '',
        topic_num: '',
        topic_dec: '',
        answer_time: '',
        answer_num: '',
      },
      /*是否上传图片*/
      isupload: false,
       /*是否正在加载*/
      loading: false,
       /*图片类别*/
      type: ''
    };
  },
  props:{
    settingData:Object
  },
  created() {
    this.getData();
  },

  methods: {
    getData(){
      let self = this;
      self.loading = true;

      TopicApi.toSettingTopic({}, true)
        .then(data => {
          self.loading = false;
          self.form = data.data.vars.values;

        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null) {
        if (this.type == 1) {
          this.form.topic = e[0].file_path;
        }


      }
      this.isupload = false;
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = self.form;
      TopicApi.settingTopic(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
        })
        .catch(error => {
          self.loading = false;
        });
    }

  }
};
</script>

<style lang="scss">
.test-wrap {
  padding: 30px;
}

.img {
  margin-top: 10px;
}

.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/topic/topic/setting.vue